export default {
  initialize: state => ({
    type: 'SELECTION_INITIALIZE',
    state,
  }),
  setSelectedItems: selectedItems => ({
    type: 'SELECTION_SET_SELECTED_ITEMS',
    selectedItems,
  }),
  setDeselectedItems: deselectedItems => ({
    type: 'SELECTION_SET_DESELECTED_ITEMS',
    deselectedItems,
  }),
  setAllItemsSelected: allItemsSelected => ({
    type: 'SELECTION_SET_ALL_ITEMS_SELECTED',
    allItemsSelected,
  }),
  setAllowSelectAll: allowSelectAll => ({
    type: 'SELECTION_SET_ALLOW_SELECT_ALL',
    allowSelectAll,
  }),
  clearSelection: () => ({
    type: 'SELECTION_CLEAR_SELECTION',
  }),
};
